import { connect } from 'react-redux';
import * as R from 'ramda';

import { getItem, setSortColumn, setSortDirection } from '../../store/rackWaitTimesSlice';
import ListLabel from './ListLabel';

const mapState = R.applySpec({
  lastFetchTime: getItem('lastFetchTime'),
  locations: getItem('locations'),
  sortColumn: getItem('sortColumn'),
  sortDirection: getItem('sortDirection'),
});

const mapDispatchToProps = {
  setSortColumn,
  setSortDirection,
};

export default connect(mapState, mapDispatchToProps)(ListLabel);
